import { inject } from '@angular/core';
import { CanDeactivateFn } from '@angular/router';
import { DialogService } from '../dialogs/services/dialog-service/dialog-service';
import { AuthService } from '../../auth/services/auth.service';

export interface HasUnsavedChanges {
  hasUnsavedChanges(): boolean;
}

export const unsavedChangesGuard: CanDeactivateFn<HasUnsavedChanges> = (component) => {
  // An ended session (expired token, 401) navigates to the login page while edits are still
  // pending. Asking to confirm would leave the user on a page whose every request now fails —
  // and the edits cannot be saved anyway, because there is no session left to save them with.
  if (!inject(AuthService).isAuthenticated()) {
    return true;
  }
  if (!component.hasUnsavedChanges()) {
    return true;
  }
  return inject(DialogService).openUnsavedChangesDialog();
};
